import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import DownloadIcon from "@material-ui/icons/CloudDownload";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import RecordsTable from "./RecordsTable.jsx";
import SearchPanel from "./SearchPanel.jsx";
import moment from "moment/moment";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import { EmptyRecord } from "../../utils/PageUtility";
import { appHelpers } from "../../_helpers/index.js";

const today = new Date();
let yesterday = new Date();
yesterday.setDate(today.getDate() - 7);

class BillablePassengers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonth: "",
      open: false,
      selectedMonthValue: "",
      selectedAirlineValue: "",
      selectedAirportValue: "",
      airlines: [],
      airports: [],
      airportCode: "-1",
      AirlineId: "-1",
      currentPage: 1,
      pageSize: 10,
      totalCounts: 0,
      records: [],
      pageRequesting: true,
      StartDate: yesterday,
      EndDate: today,
      serviceTypes: [],
      serviceType: "-1",
    };
  }

  componentDidMount() {
    let {
      regionalAirlines,
      regionalAirports,
      user,
      serviceTypes,
    } = store.getState();
    const { dispatch } = this.props;
    if (regionalAirlines) {
      this.setState({ airlines: regionalAirlines });
    } else {
      dispatch(commonActions.getAllAirlinesRegional());
    }
    if (regionalAirports) {
      this.setState({ airports: regionalAirports });
    } else {
      dispatch(commonActions.getAllAirportsRegional());
    }

    if (serviceTypes) {
      this.setState({ serviceTypes });
    } else {
      dispatch(commonActions.getAllServiceTypes());
    }

    if (user.AppRole === appConstants.ROLES.AIRLINE) {
      let userObj = { ...user };
      let userAirline = {
        value: userObj.AirlineId,
        label: userObj.AirlineName,
      };
      this.setState({ AirlineId: userAirline }, this.search);
    } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
      let userObj = { ...user };
      let userLocation = {
        value: userObj.AirportCode,
        label: userObj.Location,
      };
      this.setState({ airportCode: userLocation }, this.search);
    } else if (user.Location) {
      let userObj = { ...user };
      let userLocation = {
        value: userObj.AirportCode,
        label: userObj.Location,
      };
      this.setState({ airportCode: userLocation }, this.search);
    } else {
      this.search();
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { regionalAirlines, regionalAirports, serviceTypes } = nextProps;
    if (regionalAirlines) {
      let modifiedAirline = [...regionalAirlines];
      let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
      modifiedAirline.unshift(allAirlines);
      this.setState({ airlines: modifiedAirline });
    }
    if (regionalAirports) {
      let modifiedAirport = [...regionalAirports];
      modifiedAirport.unshift({ Name: "All Airports", Code: "-1" });
      this.setState({ airports: modifiedAirport });
    }
    if (serviceTypes) {
      let modifiedServiceTypes = [...serviceTypes];
      modifiedServiceTypes.unshift({
        Name: "All Service Types",
        Id: "-1",
      });
      this.setState({ serviceTypes: modifiedServiceTypes });
    }
  };

  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };
  handleSelectChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleReactSelectChange = (value, name) => {
    this.setState({ [name.name]: value });
    if (
      value.value === undefined ||
      value.value === "-1" ||
      value.value === "All Flights"
    ) {
      this.setState({ [name.name]: "-1" });
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  downloadReport = (type) => {
    const { dispatch } = this.props;
    const { AirlineId, StartDate, EndDate, airportCode, serviceType } = this.state;

    let payload = {
      StartDate: moment(StartDate).format("YYYY-MM-DD"),
      EndDate: moment(EndDate).format("YYYY-MM-DD"),
      Type: type,
      ServiceTypeId: serviceType.value
    };

    if (AirlineId !== "-1") payload.AirlineId = AirlineId.value;

    if (airportCode !== "-1") {
      payload.AirportCode = airportCode.value;
    }

    dispatch(alertActions.startRequest());
    commonService
      .downloadBillableVsTotalPassengersRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.success(response.Message));
          const isBase64 = !!response.base64File;
          const fileData = response.base64File || response; // filestream is in response directly
          const mimeType = appHelpers.getMimeTypeFromType(payload.Type);
          console.log(mimeType, "mimeType");
  
          appHelpers.downloadFileV2(fileData, "Total Passengers vs Billable Passengers Report", isBase64, mimeType);
          // if (response.DownloadUrl) {
          //   appHelpers.downloadFile(
          //     response.DownloadUrl,
          //     "Total Passengers vs Billable Passengers Report"
          //   );
          // } else {
          //   dispatch(alertActions.error(response.Message));
          // }
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          if (typeof res.response === "string") {
            dispatch(alertActions.error(res.response));
          } else {
            dispatch(alertActions.error(res.response.join(", ")));
          }
          this.setState({ pageRequesting: false });
        }
      });
  };

  handleSelect = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  search = (pageNumber = 1) => {
    //add AirportId, startDate & end Date
    const { AirlineId, pageSize, StartDate, EndDate, airportCode, serviceType } = this.state;
    const { dispatch } = this.props;

    let payload = {
      From: pageNumber,
      PageSize: pageSize,
      StartDate: moment(StartDate).format("YYYY-MM-DD"),
      EndDate: moment(EndDate).format("YYYY-MM-DD"),
    };
    if (AirlineId !== "-1") payload.AirlineId = AirlineId.value;
    if (airportCode !== "-1") payload.AirportCode = airportCode.value;
    if (serviceType !== "-1") payload.ServiceTypeId = serviceType.value;


    dispatch(alertActions.startRequest());
    commonService
      .searchBillableVsTotalPassengersRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response.Entity;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            currentPage: pageNumber,
            pageRequesting: false,
            records: response.Reports,
            totalCounts: response.TotalCount,
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ pageRequesting: false });
        }
      });
  };

  render() {
    const { classes, user, requesting } = this.props;
    const {
      airportCode,
      AirlineId,
      airlines,
      airports,
      name,
      currentPage,
      pageSize,
      totalCounts,
      records,
      pageRequesting,
      EndDate,
      StartDate,
      serviceTypes,
      serviceType
    } = this.state;

    if (pageRequesting) return <CircularProgress />;
    return (
      <div>
        <GridContainer>
          <SearchPanel
            user={user}
            airlines={airlines}
            airline={name}
            airports={airports}
            airportCode={
              this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
              user.Location
                ? airportCode
                : airportCode.value
            }
            handleSelect={this.handleSelect}
            selectChange={this.handleReactSelectChange}
            handleDateChange={this.handleDateChange}
            AirlineId={
              this.props.user.AppRole === appConstants.ROLES.AIRLINE
                ? AirlineId
                : AirlineId.value
            }
            EndDate={EndDate}
            StartDate={StartDate}
            onSearch={this.search}
            serviceTypes={serviceTypes}
            serviceType={serviceType.value}
          />
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="regional">
                <h4 className={classes.cardTitleWhite}>
                  Billable Passengers Utilization
                </h4>
                <p className={classes.cardCategoryWhite}>
                  {`${totalCounts}`}
                  {totalCounts === 1 && ` record `}
                  {totalCounts !== 1 && ` records `}
                  matched
                </p>
              </CardHeader>
              <CardBody>
                {!pageRequesting &&
                  totalCounts !== 0 && (
                    <RecordsTable
                      fetchMore={this.search}
                      pageSize={pageSize}
                      records={records}
                      currentPage={currentPage}
                      totalCounts={totalCounts}
                    />
                  )}

                {!pageRequesting &&
                  totalCounts === 0 && (
                    <EmptyRecord message={"No record found!"} />
                  )}
              </CardBody>
              {!pageRequesting &&
                totalCounts !== 0 && (
                  <CardFooter chart>
                    <div>
                      <Button
                        type="button"
                        color="info"
                        onClick={() => this.downloadReport("pdf")}
                        disabled={requesting}
                      >
                        <DownloadIcon />
                        Download PDF
                      </Button>
                      <Button
                        type="button"
                        color="regional"
                        onClick={() => this.downloadReport("excel")}
                        disabled={requesting}
                      >
                        <DownloadIcon />
                        Download EXCEL
                      </Button>
                    </div>
                  </CardFooter>
                )}
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    alert,
    regionalAirlines,
    regionalAirports,
    requesting,
    user,
    serviceTypes,
  } = state;
  return {
    alert,
    regionalAirlines,
    regionalAirports,
    requesting,
    user,
    serviceTypes,
  };
}
export default connect(mapStateToProps)(
  withMobileDialog()(withStyles(dashboardStyle)(BillablePassengers))
);



// WEBPACK FOOTER //
// ./src/Regional-Views/BillablePassengers/Index.jsx